var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#768896",
    d: "M7.66667 16.6667C7.66667 17.4 8.26667 18 9 18H14.3333C15.0667 18 15.6667 17.4 15.6667 16.6667V8.66667H7.66667V16.6667ZM9.30667 11.92L10.2467 10.98L11.6667 12.3933L13.08 10.98L14.02 11.92L12.6067 13.3333L14.02 14.7467L13.08 15.6867L11.6667 14.2733L10.2533 15.6867L9.31333 14.7467L10.7267 13.3333L9.30667 11.92ZM14 6.66667L13.3333 6H10L9.33333 6.66667H7V8H16.3333V6.66667H14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteColumn);
export default __webpack_public_path__ + "static/media/delete-column.07e21a4c88e6ebfbee9852bdfceeb643.svg";
export { ForwardRef as ReactComponent };